import { ca } from '@cian/analytics';

import { getSiteType } from '../../utils/getSiteType';
import { TFavoriteActionParameters } from './types';

function trackFavorite(action: 'add' | 'remove', { deviceType, position, recommendation }: TFavoriteActionParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action,
    label: `${recommendation.dealType}/${recommendation.offerType}`,
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
    },
    products: [
      {
        id: recommendation.offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackAddToFavorite(parameters: TFavoriteActionParameters) {
  trackFavorite('add', parameters);
}

export function trackDeleteFromFavorite(parameters: TFavoriteActionParameters) {
  trackFavorite('remove', parameters);
}
